var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1384,
    height: 150,
    viewBox: "0 0 1384 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "announcement",
    transform: "translate(-498 -225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12419",
    "data-name": "Group 12419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M16,0H1368a16,16,0,0,1,16,16V150a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    transform: "translate(498 225)",
    fill: "rgba(124,14,111,0.08)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12416",
    "data-name": "Group 12416",
    transform: "translate(-350 -243.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12400",
    "data-name": "Group 12400",
    transform: "translate(848 469.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12394",
    "data-name": "Group 12394",
    transform: "translate(0 76.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M89.932,313.518a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,89.932,313.518Z",
    transform: "translate(-20.634 -244.219)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M68.191,291.777a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,68.191,291.777Z",
    transform: "translate(-16.104 -239.689)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M46.451,270.036a1.553,1.553,0,1,1,0,2.2A1.554,1.554,0,0,1,46.451,270.036Z",
    transform: "translate(-11.574 -235.159)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M2.969,226.554a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,2.969,226.554Z",
    transform: "translate(-2.515 -226.1)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12395",
    "data-name": "Group 12395",
    transform: "translate(15.38 61.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M109.36,294.09a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,109.36,294.09Z",
    transform: "translate(-40.062 -224.791)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M87.619,272.349a1.554,1.554,0,1,1,0,2.2A1.553,1.553,0,0,1,87.619,272.349Z",
    transform: "translate(-35.532 -220.261)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M65.878,250.608a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,65.878,250.608Z",
    transform: "translate(-31.002 -215.731)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12396",
    "data-name": "Group 12396",
    transform: "translate(30.759 46.14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(68.844 68.844)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(51.633 51.633)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M85.306,231.18a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,85.306,231.18Z",
    transform: "translate(-50.429 -196.303)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M63.566,209.439a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,63.566,209.439Z",
    transform: "translate(-45.9 -191.774)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M41.825,187.7a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,41.825,187.7Z",
    transform: "translate(-41.37 -187.244)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12397",
    "data-name": "Group 12397",
    transform: "translate(46.14 30.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M148.216,255.234a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,148.216,255.234Z",
    transform: "translate(-78.917 -185.935)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M126.475,233.493a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,126.475,233.493Z",
    transform: "translate(-74.387 -181.405)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M104.734,211.752a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,104.734,211.752Z",
    transform: "translate(-69.857 -176.875)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M61.253,168.271a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,61.253,168.271Z",
    transform: "translate(-60.798 -167.816)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12398",
    "data-name": "Group 12398",
    transform: "translate(61.52 15.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M167.644,235.806a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,167.644,235.806Z",
    transform: "translate(-98.345 -166.507)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M145.9,214.065a1.554,1.554,0,1,1,0,2.2A1.554,1.554,0,0,1,145.9,214.065Z",
    transform: "translate(-93.815 -161.977)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M124.162,192.324a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,124.162,192.324Z",
    transform: "translate(-89.286 -157.448)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(17.211 17.211)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12399",
    "data-name": "Group 12399",
    transform: "translate(76.9 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(68.844 68.844)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 1.554,
    cy: 1.554,
    r: 1.554,
    transform: "translate(51.633 51.633)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M143.59,172.9a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,143.59,172.9Z",
    transform: "translate(-108.713 -138.019)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M121.849,151.155a1.554,1.554,0,1,1,0,2.2A1.555,1.555,0,0,1,121.849,151.155Z",
    transform: "translate(-104.184 -133.49)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M100.109,129.415a1.553,1.553,0,1,1,0,2.2A1.552,1.552,0,0,1,100.109,129.415Z",
    transform: "translate(-99.654 -128.96)",
    fill: "#ffaf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12406",
    "data-name": "Group 12406",
    transform: "translate(871.747 512.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M58.321,219.126a5.937,5.937,0,0,1-4.2-10.135,8.114,8.114,0,1,0-11.475-11.476,5.938,5.938,0,1,1-8.4-8.4,19.989,19.989,0,0,1,28.269,28.269A5.917,5.917,0,0,1,58.321,219.126Z",
    transform: "translate(-32.511 -183.273)",
    fill: "#7c0e6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12408",
    "data-name": "Group 12408",
    transform: "translate(864.743 594.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M30.668,301.4a7,7,0,1,1,7-7A7.012,7.012,0,0,1,30.668,301.4Zm0-9.505a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.668,291.891Z",
    transform: "translate(-23.664 -287.389)",
    fill: "#ffaf00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12402",
    "data-name": "Group 12402",
    transform: "translate(1320.609 230.016)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x1: 47.099,
    y1: 51.481,
    transform: "translate(87.733 20.921)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x1: 47.789,
    y1: 52.235,
    transform: "translate(95.573 52.402)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x1: 47.789,
    y1: 52.235,
    transform: "translate(123.716 26.443)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x1: 24.855,
    y1: 27.167,
    transform: "translate(112.495 101.542)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x1: 12.928,
    y1: 14.131,
    transform: "translate(180.646 74.522)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x1: 32.769,
    y1: 35.818,
    transform: "translate(69.144 62.472)",
    fill: "none",
    stroke: "#ffaf00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x1: 7.941,
    y1: 8.68,
    transform: "translate(164.865 40.717)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x1: 5.479,
    y1: 5.988,
    transform: "translate(78.071 109.03)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.655
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12417",
    "data-name": "Group 12417",
    transform: "translate(92.933 33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12403",
    "data-name": "Group 12403",
    transform: "translate(1748.904 253.986)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 13.207,
    cy: 13.207,
    r: 13.207,
    transform: "translate(4.75 4.75)",
    fill: "#ffaf00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 13.207,
    cy: 13.207,
    r: 13.207,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12415",
    "data-name": "Group 12415",
    transform: "translate(1608.416 195.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12409",
    "data-name": "Group 12409",
    transform: "translate(0 74.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M330.335,211.953a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,330.335,211.953Z",
    transform: "translate(-263.116 -144.734)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M308.595,190.212a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,308.595,190.212Z",
    transform: "translate(-258.07 -139.687)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M286.854,168.471a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,286.854,168.471Z",
    transform: "translate(-253.023 -134.641)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.694)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M243.372,124.99a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,243.372,124.99Z",
    transform: "translate(-242.931 -124.549)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12410",
    "data-name": "Group 12410",
    transform: "translate(14.919 59.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M349.763,192.525a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,349.763,192.525Z",
    transform: "translate(-282.544 -125.306)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M328.023,170.784a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,328.023,170.784Z",
    transform: "translate(-277.498 -120.259)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M306.282,149.043a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,306.282,149.043Z",
    transform: "translate(-272.451 -115.213)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12411",
    "data-name": "Group 12411",
    transform: "translate(29.837 44.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(66.778 66.778)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(50.084 50.083)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M325.71,129.615a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,325.71,129.615Z",
    transform: "translate(-291.879 -95.785)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M303.969,107.875a1.507,1.507,0,1,1,0,2.131A1.508,1.508,0,0,1,303.969,107.875Z",
    transform: "translate(-286.833 -90.739)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M282.228,86.134a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,282.228,86.134Z",
    transform: "translate(-281.787 -85.692)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12412",
    "data-name": "Group 12412",
    transform: "translate(44.756 29.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M388.619,153.669a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,388.619,153.669Z",
    transform: "translate(-321.4 -86.45)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M366.878,131.928a1.507,1.507,0,1,1,0,2.131A1.506,1.506,0,0,1,366.878,131.928Z",
    transform: "translate(-316.354 -81.403)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M345.138,110.188a1.507,1.507,0,1,1,0,2.131A1.508,1.508,0,0,1,345.138,110.188Z",
    transform: "translate(-311.307 -76.357)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.695 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M301.656,66.706a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,301.656,66.706Z",
    transform: "translate(-301.215 -66.264)",
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12413",
    "data-name": "Group 12413",
    transform: "translate(59.674 14.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M408.047,134.241a1.507,1.507,0,1,1,0,2.132A1.507,1.507,0,0,1,408.047,134.241Z",
    transform: "translate(-340.828 -67.022)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M386.306,112.5a1.507,1.507,0,1,1,0,2.131A1.506,1.506,0,0,1,386.306,112.5Z",
    transform: "translate(-335.781 -61.975)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M364.566,90.76a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,364.566,90.76Z",
    transform: "translate(-330.735 -56.929)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(16.694 16.695)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    fill: "#ff5e1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12414",
    "data-name": "Group 12414",
    transform: "translate(74.592 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(66.778 66.778)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 1.507,
    cy: 1.507,
    r: 1.507,
    transform: "translate(50.084 50.083)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M383.994,71.332a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,383.994,71.332Z",
    transform: "translate(-350.163 -37.501)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M362.253,49.591a1.507,1.507,0,1,1,0,2.132A1.508,1.508,0,0,1,362.253,49.591Z",
    transform: "translate(-345.117 -32.455)",
    fill: "#ff5e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M340.512,27.85a1.507,1.507,0,1,1,0,2.131A1.507,1.507,0,0,1,340.512,27.85Z",
    transform: "translate(-340.07 -27.409)",
    fill: "#ff5e1e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12418",
    "data-name": "Group 12418",
    transform: "translate(1160.543 -40.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M466.468,271.84a8.847,8.847,0,1,1,8.847-8.847A8.856,8.856,0,0,1,466.468,271.84Zm0-12.007a3.16,3.16,0,1,0,3.16,3.16A3.164,3.164,0,0,0,466.468,259.833Z",
    fill: "#7c0e6f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12420",
    "data-name": "Group 12420",
    transform: "translate(0 -0.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12393",
    "data-name": "Group 12393",
    transform: "translate(806.485 -82.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M114.938,391.976l-11.884-18.935a11.226,11.226,0,0,0,1.873-2.053,11.346,11.346,0,0,0,2.02-7.2,11.205,11.205,0,0,0-.692-3.238,11.34,11.34,0,0,0-1.016-2.052c-.079-.126-.163-.248-.245-.37l0,.012a11.292,11.292,0,0,0-13.8-4L78.844,334.467a2.458,2.458,0,0,0-3.389-.775,2.411,2.411,0,0,0-.348.271l-.025-.037-.028.081a2.459,2.459,0,0,0-.724,2.079,75.666,75.666,0,0,1-21.08,31.791l-6.177,5.491-.48.334-10.343,7.2a12.5,12.5,0,0,0-5.027,7.667l0-.008c-.019.086-.026.174-.043.26-.069.341-.129.683-.173,1.031-.017.14-.027.281-.041.421-.03.322-.053.646-.062.972,0,.16,0,.318,0,.478,0,.311.012.621.034.933q.018.258.045.516c.032.3.074.6.124.906.029.178.06.357.1.535.061.3.134.592.213.886.048.181.093.361.148.541.063.205.135.409.207.614l-.1.063a7.4,7.4,0,0,0-2.335,10.206,7.251,7.251,0,0,0,10,2.286l.47-.295a14.283,14.283,0,0,0,9.42,3.711,12.283,12.283,0,0,0,4.828-.989,58.7,58.7,0,0,1,10.849,20.2c2.785,9.279,7.655,10.941,11.146,9.709l.072-.025a6.559,6.559,0,0,0,1.271-.628l.083-.053a6.656,6.656,0,0,0,1.047-.848l.094-.094a6.243,6.243,0,0,0,.428-.484l.009-.012c.125-.16.238-.326.345-.493.028-.043.054-.086.08-.129a5.531,5.531,0,0,0,.282-.531c2.205-4.867.115-12.872-4.033-20.831a72.3,72.3,0,0,0-4.75-7.826q-.878-1.263-1.8-2.48c-.753-.993-1.527-1.953-2.313-2.883l7.5-3.292a73.872,73.872,0,0,1,20.723-5.66q2.391-.292,4.812-.435t4.86-.131c2.109.009,4.228.113,6.353.295a2.457,2.457,0,0,0,3.061.363c.033-.02.059-.048.09-.07l.019,0-.007-.011A2.451,2.451,0,0,0,114.938,391.976Z",
    transform: "translate(-1.899 -1.688)",
    fill: "#606060",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12388",
    "data-name": "Group 12388",
    transform: "translate(17.741 332.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12376",
    "data-name": "Group 12376",
    transform: "translate(24.034 67.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12374",
    "data-name": "Group 12374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M47.111,425.654a57.038,57.038,0,0,1,12.663,22.232c4.137,13.783,12.88,10.771,14.857,6.409,3.921-8.651-5.737-27.223-16.387-37.821",
    transform: "translate(-47.111 -416.474)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12375",
    "data-name": "Group 12375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M58.244,416.474l-11.133,9.18s.616.613,1.592,1.768a2.048,2.048,0,0,1,1.872-1.038c8.314-.033,14.175,7.128,17.857,13.84,3.128,5.706,4.335,11.926,1.794,17.576a6.521,6.521,0,0,0,4.4-3.5C78.552,445.644,68.894,427.072,58.244,416.474Z",
    transform: "translate(-47.111 -416.474)",
    fill: "#ed9f03"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12379",
    "data-name": "Group 12379",
    transform: "translate(56.158 19.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12377",
    "data-name": "Group 12377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M107.251,364.06a11.306,11.306,0,1,1-15.587-3.566A11.307,11.307,0,0,1,107.251,364.06Z",
    transform: "translate(-86.367 -358.763)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12378",
    "data-name": "Group 12378",
    transform: "translate(0.003 4.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M86.372,371.031a11.305,11.305,0,1,0,20.879-5.877c-.079-.126-.162-.249-.245-.371C104.56,372.443,93.649,375.478,86.372,371.031Z",
    transform: "translate(-86.371 -364.783)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12380",
    "data-name": "Group 12380",
    transform: "translate(0 62.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M29.946,423.626l-1.075.675a7.251,7.251,0,0,1-10-2.287h0a7.4,7.4,0,0,1,2.335-10.205l.947-.594Z",
    transform: "translate(-17.741 -411.215)",
    fill: "#7c0e6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12383",
    "data-name": "Group 12383",
    transform: "translate(18.397 0.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12381",
    "data-name": "Group 12381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M87.726,363.434,68.712,335.215l-.718,2.065A75.678,75.678,0,0,1,46.88,369.166L40.7,374.657l-.48.334,19.45,30.989.748-.44,7.565-3.319a75.4,75.4,0,0,1,37.745-5.849l2.173.213L90.291,367.465l-1.32-2.183Z",
    transform: "translate(-40.222 -335.215)",
    fill: "#7c0e6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12382",
    "data-name": "Group 12382",
    transform: "translate(14.69 43.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M87.37,393.423c-6.617,3.043-13.115,6.391-19.613,9.677q-4.841,2.448-9.583,5.049l4.76,7.585.748-.44,7.565-3.319a75.4,75.4,0,0,1,37.745-5.849l2.173.213L100.618,388.9A58.146,58.146,0,0,0,87.37,393.423Z",
    transform: "translate(-58.173 -388.903)",
    fill: "#52144a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12384",
    "data-name": "Group 12384",
    transform: "translate(46.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M113.945,396.517h0a2.458,2.458,0,0,1-3.389-.775L74.462,338.233a2.457,2.457,0,0,1,.775-3.388h0a2.458,2.458,0,0,1,3.389.775l36.094,57.508A2.458,2.458,0,0,1,113.945,396.517Z",
    transform: "translate(-74.086 -334.469)",
    fill: "#ffaf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12387",
    "data-name": "Group 12387",
    transform: "translate(2.687 40.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12385",
    "data-name": "Group 12385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M26.391,391.017c-5.886,4.1-7.117,12.655-2.764,19.231l1.592,2.4,1.766,2.866c4.137,6.715,12.41,9.182,18.588,5.542l10.611-6.25-19.45-30.989Z",
    transform: "translate(-21.024 -383.822)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12386",
    "data-name": "Group 12386",
    transform: "translate(0.003 14.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M34.687,413.088c-5.5-1.539-10.643-6.085-13.325-11.114a15.136,15.136,0,0,0,2.267,11.573l1.592,2.4,1.766,2.866c4.137,6.715,12.41,9.182,18.588,5.542l10.611-6.25-4.9-7.811C46.28,412.445,40.017,414.579,34.687,413.088Z",
    transform: "translate(-21.028 -401.974)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12392",
    "data-name": "Group 12392",
    transform: "translate(99.266 324.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12389",
    "data-name": "Group 12389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M118.155,344.148a.789.789,0,0,1-.613-1.286L132.56,324.32a.789.789,0,1,1,1.227.993l-15.017,18.542A.788.788,0,0,1,118.155,344.148Z",
    transform: "translate(-117.366 -324.027)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12390",
    "data-name": "Group 12390",
    transform: "translate(6.883 35.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M150.205,372.627a.7.7,0,0,1-.11-.007l-23.637-3.259a.789.789,0,1,1,.216-1.563l23.637,3.259a.789.789,0,0,1-.106,1.571Z",
    transform: "translate(-125.777 -367.788)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12391",
    "data-name": "Group 12391",
    transform: "translate(7.431 15.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M127.237,354.643a.79.79,0,0,1-.34-1.5l21.545-10.255a.79.79,0,0,1,.679,1.426l-21.546,10.255A.8.8,0,0,1,127.237,354.643Z",
    transform: "translate(-126.447 -342.809)",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Announcement",
    transform: "translate(1033 280)",
    fill: "#7c0e6f",
    fontSize: 24,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -82,
    y: 0
  }, "Announcement"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.194a1a740f584fa546e674cd0392679d.svg";
export { ForwardRef as ReactComponent };